import { QApi, PublicQApi } from '../baseQuery';
import {
  CREATE_QUEUE,
  GET_QUEUE_DETAIL,
  UPDATE_QUEUE,
  ADD_USER_QUEUE,
  GET_APPOINTMENT_SLOT_LIST,
  QUEUE_USER_ADD_MOBILE_NUMBER_OWNER,
  GET_USER_QUEUE_DETAIL,
  GET_QUEUE_ACTION_DETAIL,
  SEND_OTP_FOR_ANONYMOUS_USER,
  JOIN_QUEUE,
  DELETE_QUEUE,
  GET_USER_JOIN_DROP_DOWN_LIST,
  USER_LEAVE_QUEUE,
  DOWNLOAD_QR_CODE_PDF,
  QUEUE_USER_CONFIRM_CHECK_AVAIBILITY,
  ADD_APPOINTMENT_USER_REQUEST_TO_QUEUE,
  ASSIGN_USER_TO_QUEUE,
  BATCH_PROCESS_ACTION,
  BATCH_SERVING_USER_ACTION,
  CONTINUE_JOIN_EXISTING_USER,
  FETCH_USER_INTEREST_INTO_QUEUE,
  GET_ADVANCED_BOOKING_SLOT_DETAIL,
  GET_QUEUE_LIST,
  GET_USER_QUEUE_LIST,
  GET_USER_QUEUE_SLOT_DETAIL,
  MANAGE_APPOINTMENT_ACTION,
  MOVE_TO_END_QUEUE,
  MOVE_TO_WAITING_QUEUE,
  REMOVE_USER_QUEUE,
  SKIP_USER_QUEUE,
  UNDO_PROCESS_ACTION,
  UPDATE_USER_SERVING_TIME,
  USER_QUEUE_INTEREST_DETAIL,
  BATCH_BOOKING_SLOT,
  DEFAULT_QUEUE_USER_STATUSES_FILTER,
  GET_LOCATION_LIST,
  WALLET_CREDIT_PAYMENT,
  CREDIT_PURCHASE,
  GET_WALLET_BALANCE_LOG,
  GET_WALLET_PAYMENT_TRANSACTIONS,
  GET_TRANSACTION_DETAIL,
  GET_BUSINESS_DETAIL,
} from '../../config/ApiList';
export const QueueApi = QApi.injectEndpoints({
  endpoints: (builder) => ({
    createQueue: builder.mutation({
      query: (body) => {
        return {
          url: `queue`,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getQueueDetail: builder.query({
      query: (params) => {
        return {
          url: `queue/${params.id}`,
          method: 'GET',
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    updateQueue: builder.mutation({
      query: ({ body, qid }) => {
        return {
          url: `queue/${qid}`,
          method: 'PUT',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    addUserQueue: builder.mutation({
      query: ({ body, qid }) => {
        return {
          url: `queue/${qid}/add-user`,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getAppointmentSlotList: builder.mutation({
      query: ({ body, qid }) => {
        return {
          url: `queue/${qid}/booking-slots`,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    addAnonymouseUserMobileNumber: builder.mutation({
      query: ({ body, queue_user_id }) => {
        return {
          url: `${QUEUE_USER_ADD_MOBILE_NUMBER_OWNER}/${queue_user_id}/convert-to-known-user`,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getBatchSlotList: builder.mutation({
      query: ({ body, qid }) => {
        return {
          url: `queue/${qid}/batch-booking-slots`,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getUserQueueDetail: builder.query({
      query: (params) => {
        return {
          url: `queue-user/${params.id}`,
          method: 'GET',
          params: params,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getQueueActionDetail: builder.query({
      query: (params) => {
        return {
          url: `${GET_QUEUE_ACTION_DETAIL}/${params.id}/manage-walkin-queue`,
          method: 'GET',
          params,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    sendOtpForAnonymouseUser: builder.mutation({
      query: (body) => {
        return {
          url: SEND_OTP_FOR_ANONYMOUS_USER,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    otpVerifyForAnonymousUser: builder.mutation({
      query: ({ body, queue_user_id }) => {
        return {
          url: `queue-user/${queue_user_id}/convert-to-known-user`,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getAppointmentUserList: builder.query({
      query: (params) => {
        return {
          url: `${GET_QUEUE_ACTION_DETAIL}/${params.id}/manage-appointment-queue`,
          method: 'GET',
          params,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getQueueUserActionList: builder.query({
      query: (params) => {
        return {
          url: `queue-user/${params.id}/available-actions`,
          method: 'GET',
          params,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getQueueServicesList: builder.query({
      query: (params) => {
        return {
          url: `queue/${params.id}/services`,
          method: 'GET',
          params,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    queueUserDetailUpdate: builder.mutation({
      query: ({ body, queue_user_id }) => {
        return {
          url: `queue-user/${queue_user_id}`,
          method: 'PATCH',
          body: body,
        };
      },
      transformErrorResponse: (response, meta, arg) => response,
      invalidatesTags: ['QueueApi'],
    }),
    joinQueue: builder.mutation({
      query: (body) => {
        return {
          url: JOIN_QUEUE,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    updateQueueStatus: builder.mutation({
      query: ({ body, queue_id }) => {
        return {
          url: `queue/${queue_id}/status`,
          method: 'PATCH',
          body: body,
        };
      },
      transformErrorResponse: (response, meta, arg) => response,
      invalidatesTags: ['QueueApi'],
    }),
    queueUserActionPerform: builder.mutation({
      query: ({ body, queue_user_id }) => {
        return {
          url: `queue-user/${queue_user_id}/action`,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getUserJoinQueueDropDownList: builder.query({
      query: () => {
        return {
          url: GET_USER_JOIN_DROP_DOWN_LIST,
          method: 'GET',
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    leaveQueue: builder.mutation({
      query: (body) => {
        return {
          url: USER_LEAVE_QUEUE + '/' + body?.queue_user_id,
          method: 'POST',
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    nextUserQueue: builder.mutation({
      query: (body) => {
        return {
          url: `queue-user/${body.queue_id}/next-user`,
          method: 'POST',
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    downloadQrCodePdf: builder.mutation({
      query: (params) => {
        return {
          url: `queue/${params.id}/qr-code/download`,
          method: 'GET',
          params,
          responseHandler: (response) => response.arrayBuffer(),
        };
      },
      keepUnusedDataFor: 0,
      invalidatesTags: ['QueueApi'],
      // Transform response to make ArrayBuffer serializable
      transformResponse: (response) => {
        // Convert ArrayBuffer to Uint8Array which is serializable
        if (response instanceof ArrayBuffer) {
          return {
            data: Array.from(new Uint8Array(response)), // Convert to regular array
            size: response.byteLength,
            type: 'application/pdf',
            timestamp: Date.now(),
          };
        }
        return response;
      },
    }),
    downloadBusinessQrCodePdf: builder.mutation({
      query: (params) => {
        return {
          url: `business/${params.id}/qr-code/download`,
          method: 'GET',
          params,
          responseHandler: (response) => response.arrayBuffer(),
        };
      },
      keepUnusedDataFor: 0,
      invalidatesTags: ['QueueApi'],
      // Transform response to make ArrayBuffer serializable
      transformResponse: (response) => {
        // Convert ArrayBuffer to Uint8Array which is serializable
        if (response instanceof ArrayBuffer) {
          return {
            data: Array.from(new Uint8Array(response)), // Convert to regular array
            size: response.byteLength,
            type: 'application/pdf',
            timestamp: Date.now(),
          };
        }
        return response;
      },
    }),
    queueConfirmCheckAvailability: builder.mutation({
      query: ({ body, queue_id }) => {
        return {
          url: `queue/${queue_id}/check-availability`,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    joinInterest: builder.mutation({
      query: ({ body, queue_id }) => {
        return {
          url: `queue-user/${queue_id}/register-interest`,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    seatUpdateServingCapacity: builder.mutation({
      query: ({ body, queue_id }) => {
        return {
          url: `queue/${queue_id}/serving-capacity`,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getManageBatchQueue: builder.query({
      query: (params) => {
        return {
          url: `${GET_QUEUE_ACTION_DETAIL}/${params.id}/manage-batch-queue?booking_date=${params.booking_date || params.booking_datetime}`,
          method: 'GET',
          params,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),

    undoProcessQueue: builder.mutation({
      query: (body) => {
        return {
          url: UNDO_PROCESS_ACTION,
          method: 'PUT',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    batchProcessQueue: builder.mutation({
      query: (body) => {
        return {
          url: BATCH_PROCESS_ACTION,
          method: 'PUT',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    batchServingUser: builder.mutation({
      query: (body) => {
        return {
          url: BATCH_SERVING_USER_ACTION,
          method: 'PUT',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getQueueDetail: builder.query({
      query: (params) => {
        return {
          url: GET_QUEUE_DETAIL + '/' + params.id,
          method: 'GET',
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getQueueDetailEditPage: builder.query({
      query: (params) => {
        return {
          url: GET_QUEUE_DETAIL + '/' + params.id,
          method: 'GET',
          params,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getQueueList: builder.query({
      query: (params) => {
        return {
          url: GET_QUEUE_LIST,
          method: 'GET',
          params: params,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getUserQueueList: builder.query({
      query: (params) => {
        return {
          url: GET_USER_QUEUE_LIST,
          method: 'GET',
          params: params,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),

    assignUserToQueue: builder.mutation({
      query: (body) => {
        return {
          url: ASSIGN_USER_TO_QUEUE,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    addAppointmentRequestUserToQueue: builder.mutation({
      query: (body) => {
        return {
          url: ADD_APPOINTMENT_USER_REQUEST_TO_QUEUE,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getUserQueueSlotDetail: builder.query({
      query: (id) => {
        return {
          url: GET_USER_QUEUE_SLOT_DETAIL + '/' + id,
          method: 'GET',
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    continueJoinExistingUser: builder.mutation({
      query: (body) => {
        return {
          url: CONTINUE_JOIN_EXISTING_USER,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    updateUserServingTime: builder.mutation({
      query: (body) => {
        return {
          url: UPDATE_USER_SERVING_TIME,
          method: 'PUT',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getAdvancedBookingSlotDetail: builder.query({
      query: (params) => {
        return {
          url: GET_ADVANCED_BOOKING_SLOT_DETAIL + '/' + params.id,
          method: 'GET',
          params,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    manageAppointmentAction: builder.mutation({
      query: (body) => {
        return {
          url: MANAGE_APPOINTMENT_ACTION,
          method: 'PUT',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getUserQueueInterestDetail: builder.query({
      query: (params) => {
        return {
          url: USER_QUEUE_INTEREST_DETAIL + '/' + params.id,
          method: 'GET',
          params,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    fetchUserInterestList: builder.query({
      query: (params) => {
        return {
          url: FETCH_USER_INTEREST_INTO_QUEUE + '/' + params.id,
          method: 'GET',
          params,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getSearchQueueUsers: builder.query({
      query: ({
        term,
        page,
        page_size,
        booking_date,
        queue_id,
        batch_id,
        statuses,
      }) => {
        return {
          url: 'queue-user/search',
          method: 'GET',
          params: {
            term,
            page,
            page_size,
            booking_date,
            queue_id,
            batch_id,
            statuses,
          },
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getQueueReviews: builder.query({
      query: ({ queue_id, page, page_size }) => {
        return {
          url: `queue/${queue_id}/review`,
          method: 'GET',
          params: { page, page_size },
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    ratingQueue: builder.mutation({
      query: ({ body, queue_user_id }) => {
        return {
          url: `queue-user/${queue_user_id}/review`,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getLocationList: builder.query({
      query: () => {
        return {
          url: GET_LOCATION_LIST,
          method: 'GET',
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    addManagerToQueue: builder.mutation({
      query: ({ body, queue_id }) => {
        return {
          url: `queue/${queue_id}/managers`,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    deleteManagerFromQueue: builder.mutation({
      query: ({ queue_id, manager_id }) => {
        return {
          url: `queue/${queue_id}/managers/${manager_id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getQueueManagers: builder.query({
      query: (queue_id) => {
        return {
          url: `queue/${queue_id}/managers`,
          method: 'GET',
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    walletCreditPayment: builder.mutation({
      query: (body) => {
        return {
          url: WALLET_CREDIT_PAYMENT,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    creditPurchase: builder.mutation({
      query: ({ businessId, amount }) => {
        return {
          url: `${CREDIT_PURCHASE}?business_id=${businessId}`,
          method: 'POST',
          body: { amount },
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getWalletBalanceLog: builder.query({
      query: (params) => {
        return {
          url: GET_WALLET_BALANCE_LOG,
          method: 'GET',
          params,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getWalletPaymentTransactions: builder.query({
      query: (params) => {
        return {
          url: GET_WALLET_PAYMENT_TRANSACTIONS,
          method: 'GET',
          params,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getTransactionDetail: builder.query({
      query: (transactionId) => {
        return {
          url: `${GET_TRANSACTION_DETAIL}/${transactionId}`,
          method: 'GET',
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getTransactionInvoice: builder.query({
      query: (transactionId) => {
        return {
          url: `api/payment/${transactionId}/invoice`,
          method: 'GET',
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getBusinessDetail: builder.query({
      query: ({
        businessId,
        excludeStatuses = [],
        includeManagedQueues = false,
      }) => {
        const params = {};
        if (excludeStatuses.length > 0) {
          params.exclude_statuses = excludeStatuses.join(',');
        }
        if (includeManagedQueues) {
          params.include_managed_queues = true;
        }
        return {
          url: `${GET_BUSINESS_DETAIL}/${businessId}?exclude_statuses=archived,deleted,completed,stopped,closed${includeManagedQueues ? '&include_managed_queues=true' : ''}`,
          method: 'GET',
          params,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getServiceOrderList: builder.query({
      query: (params) => {
        return {
          url: 'business/service-order',
          method: 'GET',
          params: params,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getSalesStats: builder.query({
      query: (params) => {
        return {
          url: 'business/sales-stats',
          method: 'GET',
          params: params,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getFilteredSalesStats: builder.query({
      query: (params) => {
        return {
          url: 'business/sales-stats-filtered',
          method: 'GET',
          params: params,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    markOfflinePaymentSuccess: builder.mutation({
      query: (paymentId) => {
        return {
          url: `payment/${paymentId}/mark-offline-success`,
          method: 'PATCH',
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    addBusinessPaymentDetail: builder.mutation({
      query: ({ business_id, body }) => {
        return {
          url: `business/${business_id}/add-account-detail`,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    getBusinessAccounts: builder.query({
      query: (business_id) => {
        return {
          url: `business/${business_id}/accounts`,
          method: 'GET',
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    deleteBusinessAccount: builder.mutation({
      query: ({ business_id, business_account_detail_id }) => {
        return {
          url: `business/${business_id}/delete/${business_account_detail_id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    resendBusinessVerification: builder.mutation({
      query: (business_id) => {
        return {
          url: `business/${business_id}/resend-verification-email`,
          method: 'GET',
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    updateBusinessAccount: builder.mutation({
      query: ({ business_id, business_account_detail_id, body }) => {
        return {
          url: `business/${business_id}/update-account-detail/${business_account_detail_id}`,
          method: 'PUT',
          body: body,
        };
      },
      invalidatesTags: ['QueueApi'],
    }),
    validateQueueName: builder.query({
      query: ({ name, queue_id }) => {
        const params = { name };
        // Only include queue_id if it's a valid UUID
        if (queue_id && queue_id !== 'null' && queue_id !== null) {
          params.queue_id = queue_id;
        }
        return {
          url: 'queue/validate-name',
          method: 'GET',
          params,
        };
      },
      keepUnusedDataFor: 0, // Don't cache validation results
    }),
    getAutoEnrollmentSchedule: builder.query({
      query: ({ queue_user_id, days_ahead }) => {
        const params = {};
        // Only include days_ahead if provided (otherwise API will use queue end date)
        if (days_ahead !== undefined && days_ahead !== null) {
          params.days_ahead = days_ahead;
        }
        return {
          url: `queue-user/${queue_user_id}/auto-enrollment-schedule`,
          method: 'GET',
          params,
        };
      },
      providesTags: ['QueueApi'],
    }),

    // Secure File Access endpoints
    getSecureAttachment: builder.query({
      query: ({ queueUserId, objectName }) => {
        return {
          url: `queue-user/${queueUserId}/attachment/${objectName}`,
          method: 'GET',
          responseHandler: (response) => response.blob(),
        };
      },
      keepUnusedDataFor: 0,
      providesTags: ['SecureAttachment'],
      // Transform response to prevent Blob storage in Redux state
      transformResponse: async (response) => {
        // Convert Blob to a serializable format
        if (response instanceof Blob) {
          // Convert Blob to ArrayBuffer, then to regular array for serialization
          const arrayBuffer = await response.arrayBuffer();
          const uint8Array = new Uint8Array(arrayBuffer);
          const numberArray = Array.from(uint8Array);

          return {
            data: numberArray,
            size: response.size,
            type: response.type,
            timestamp: Date.now(),
          };
        }
        return response;
      },
    }),

    getUserAttachments: builder.query({
      query: (userId) => {
        return {
          url: `user/attachments/${userId}`,
          method: 'GET',
        };
      },
      providesTags: ['UserAttachments'],
    }),

    getAttachmentById: builder.query({
      query: (attachmentId) => {
        return {
          url: `attachment/${attachmentId}`,
          method: 'GET',
          responseHandler: (response) => response.blob(),
        };
      },
      keepUnusedDataFor: 300, // Cache for 5 minutes
      providesTags: ['Attachment'],
      // Transform response to prevent Blob storage in Redux state
      transformResponse: async (response) => {
        if (response instanceof Blob) {
          // Convert Blob to ArrayBuffer, then to regular array for serialization
          const arrayBuffer = await response.arrayBuffer();
          const uint8Array = new Uint8Array(arrayBuffer);

          return {
            data: Array.from(uint8Array), // Convert to regular array for Redux serialization
            type: response.type,
            size: response.size,
          };
        }
        return response;
      },
    }),
  }),
});

export const {
  useCreateQueueMutation,
  useGetQueueDetailQuery,
  useUpdateQueueMutation,
  useAddUserQueueMutation,
  useGetAppointmentSlotListMutation,
  useAddAnonymouseUserMobileNumberMutation,
  useGetUserQueueDetailQuery,
  useGetQueueActionDetailQuery,
  useSendOtpForAnonymouseUserMutation,
  useOtpVerifyForAnonymousUserMutation,
  useGetAppointmentUserListQuery,
  useGetQueueUserActionListQuery,
  useGetQueueServicesListQuery,
  useQueueUserDetailUpdateMutation,
  useJoinQueueMutation,
  useUpdateQueueStatusMutation,
  useQueueUserActionPerformMutation,
  useGetUserJoinQueueDropDownListQuery,
  useDownloadQrCodePdfMutation,
  useDownloadBusinessQrCodePdfMutation,
  useQueueConfirmCheckAvailabilityMutation,
  useJoinInterestMutation,
  useSeatUpdateServingCapacityMutation,
  useGetManageBatchQueueQuery,
  useGetQueueListQuery,
  useGetQueueDetailEditPageQuery,
  useNextUserQueueMutation,
  useBatchProcessQueueMutation,
  useBatchServingUserMutation,
  useUndoProcessQueueMutation,
  useGetUserQueueListQuery,
  useAssignUserToQueueMutation,
  useAddAppointmentRequestUserToQueueMutation,
  useGetUserQueueSlotDetailQuery,
  useLeaveQueueMutation,
  useContinueJoinExistingUserMutation,
  useUpdateUserServingTimeMutation,
  useGetAdvancedBookingSlotDetailQuery,
  useManageAppointmentActionMutation,
  useGetUserQueueInterestDetailQuery,
  useFetchUserInterestListQuery,
  useGetBatchSlotListMutation,
  useGetSearchQueueUsersQuery,
  useGetQueueReviewsQuery,
  useRatingQueueMutation,
  useGetLocationListQuery,
  useAddManagerToQueueMutation,
  useDeleteManagerFromQueueMutation,
  useGetQueueManagersQuery,
  useGetWalletBalanceLogQuery,
  useGetWalletPaymentTransactionsQuery,
  useWalletCreditPaymentMutation,
  useCreditPurchaseMutation,
  useGetTransactionDetailQuery,
  useGetTransactionInvoiceQuery,
  useGetBusinessDetailQuery,
  useGetServiceOrderListQuery,
  useGetSalesStatsQuery,
  useGetFilteredSalesStatsQuery,
  useMarkOfflinePaymentSuccessMutation,
  useAddBusinessPaymentDetailMutation,
  useGetBusinessAccountsQuery,
  useDeleteBusinessAccountMutation,
  useResendBusinessVerificationMutation,
  useUpdateBusinessAccountMutation,
  useValidateQueueNameQuery,
  useGetAutoEnrollmentScheduleQuery,
  useGetSecureAttachmentQuery,
  useGetUserAttachmentsQuery,
  useGetAttachmentByIdQuery,
} = QueueApi;

// Public API for unauthenticated requests (bypass OTP flow)
export const PublicQueueApi = PublicQApi.injectEndpoints({
  endpoints: (builder) => ({
    getPublicQueueDetail: builder.query({
      query: (params) => {
        return {
          url: `queue/${params.id}`,
          method: 'GET',
        };
      },
      invalidatesTags: ['PublicQueueApi'],
    }),
  }),
});

export const { useGetPublicQueueDetailQuery } = PublicQueueApi;
